import { IfLoggedInDirectiveDef } from '@df/session/customer/if-logged-in.directive.def';
import { Directive } from '@angular/core';

/**
 * Use this directive to present element only in user is logged in
 *
 * ```html
 * <div *ifLoggedIn>...</div>
 * ```
 */
// @Directive({
//     selector: '[ifNotLoggedIn]'
// })
@Directive()
export abstract class IfNotLoggedInDirectiveDef extends IfLoggedInDirectiveDef {
    /**
     * Updates condition
     */
    protected override update() {
        this.ngIf = !this.customer.model.isLoggedIn;
    }
}
